<template>

  <div :style="{zIndex,width,left,top,height}" style="position: absolute;display:flex;width: 100%;background: white;overflow: hidden;
    border: 1px solid #dcdfe6;border-radius: 4px;box-sizing: border-box;" v-clickoutside="hide">
    <el-select ref="select" v-model="countryCode" placeholder="国家"
               :size="size"
               :filterable="filterable"
               :disabled="readonly"
               class="bd_none" style="border-right: 1px solid #dcdfe6;flex:1">
      <el-option
          v-for="item in countryList"
          :key="item.key"
          :label="item.label"
          :value="item.key">
        <div @click="$event=>beforeCountryChange?beforeCountryChange($event,item):void 0">{{ item.label }}</div>
      </el-option>
    </el-select>
    <el-cascader
        id="regionSelect"
        v-model="vModel"
        class="bd_none"
        ref="refArea"
        :size="size"
        :options="areaList"
        :props="{ expandTrigger: 'hover' ,value:'areaName',label:'areaName',checkStrictly:false}"
        :placeholder="placeholder"
        :disabled="readonly"
        :handleSuggestion="handleSuggestion"
        @change="change"
        style="flex:2"
        :filter-method="regionFilterMethod"
        :filterable="filterable"
        :clearable="clearable">
        <div slot-scope="{ node, data }" @click="$event=>optClick($event,node,data)">{{ data.areaName }}</div>
    </el-cascader>
  </div>
</template>

<script>
import region from "@/common/api/region";
import Clickoutside from 'element-ui/src/utils/clickoutside';
import country from "@/common/api/country";

export default {
  name: "RegionSelect",
  directives: { Clickoutside },
  props: {
  },
  data() {
    return {
      vModel:"",
      countryCode:"",
      form: {
        id:          null,
        code:        null,
        post:        null,
        region:      null,
        regionSep:   null,
        country:     null,
        countryCode: null,
      },
      size:"small",
      zIndex:-1,
      width: "0",
      height: "0",
      left: "0",
      top: "0",
      visible:false,
      areaList: [],
      countryList: [],

      clearable:true,
      filterable:true,
      readonly:false,
      beforeChange:null,
      placeholder:"请选择",
    }
  },
  async mounted() {
    // console.red('......................', this.$refs.select, this);
    this.$emit('init', this);
    this.countryList = await country.getList();
    // 在使用指令的组件 data 里定义 popperElm 属性，它的值是一个 dom
    this.popperElm = document.querySelector('.el-select-dropdown.el-popper');
  },
  methods: {
    regionFilterMethod(node, keyword){
      return node.text.toLowerCase().includes(keyword.toLowerCase());
    },
    handleSuggestion(event, node) {
      if (!this.beforeChange) {
        return true;
      }
      let country = this.$refs.select.$refs.reference.value;
      let countryCode = this.countryCode;
      let data = node.data;
      let param = {
        id: data.id,
        code: data.code,
        post: data.postCode,
        region: country + " " + node.pathLabels.join(' '),
        regionSep: [country, ...node.pathLabels],
        countryCode,
        country: country,
      };
      // console.log(' .... param',param);
      this.beforeChange(event, param);
      return false;
    },
    beforeCountryChange(event,item){
      this.countryCode = item.key;
      this.country = item.label;
      this.loadRegion();
    },
    stopPosition(e){
      console.log(e);
      this.hide();
    },
    show({rect, form,options}){
      this.visible = true;
      this.zIndex = 9999;
      this.width = rect.width + 'px';
      this.height = rect.height + 'px';
      this.left = rect.left + 'px';
      this.top = rect.top + 'px';
      this.$refs.select.toggleMenu();
      let $refArea = this.$refs.refArea;
      $refArea.toggleDropDownVisible(false);
      // $refArea.toggleDropDownVisible(true);
      if(options){
        this.size = options.size || 'small';
        this.clearable = !!options.clearable;
        this.filterable = !!options.filterable;
        this.readonly = !!options.readonly;
        this.beforeChange = options.beforeChange;
        this.changeOutter = options.change;
      }
      this.form = form;
      if (!this.areaList.length) {
        this.loadData();
      }else{
        this.vModel = this.form.regionSep;
      }
    },
    hide(){
      if(!this.visible){
        return;
      }
      console.log("hide inner");
      this.visible = false;
      this.zIndex = -1;
    },
    selectVisibleChange(selectVisible){
      if (selectVisible) {
        this.$refs.refArea.toggleDropDownVisible(false);
      }
    },
    async loadRegion(){
      await this.loadData();
      this.$refs.refArea.toggleDropDownVisible(true);
    },
    async loadData(){
      let list = await region.getListByCountry(this.countryCode);
      if(!list){
        console.red('Region Inner list', list);
        this.areaList = [];
        this.vModel = '';
        return;
      }
      console.red('Region Inner list length', list.length);
      this.areaList = list;
      let match = true;
      let tempList = list;
      for (let i = 0; i < this.regionSep && this.regionSep.length; i++) {
        let e = this.regionSep[i];
        let find = tempList.find(ls => ls.areaName === e);
        if (!find) {
          match = false;
          break
        }
        tempList = find.children
      }
      if (!match) {
        this.form.id = '';
        this.form.code = '';
        this.form.post = '';
        this.form.region = '';
        this.form.regionSep = [];
        this.form.country = '';
        this.form.countryCode = '';
      }
      this.vModel = '';
    },
    unloadData(){
      this.areaList.length = 0;
    },
    optClick(event,node,data){
      this.hide();
      // 非子节点不拦截事件
      if(!this.beforeChange || node.hasChildren){
        return;
      }
      let param = {
        id: data.id,
        code: data.code,
        post: data.postCode,
        region: node.pathLabels.join(' '),
        regionSep: node.pathLabels,
        countryCode: this.form.countryCode,
        country: this.form.country,
      };
      this.beforeChange(event, param);
    },
    checkSep(sep,list){

      return true;
    },
    change(val) {

      console.log('do methods change ', this.changeOutter);

      this.$nextTick(() => {
        let nodes = this.$refs.refArea.getCheckedNodes();
        if (nodes && nodes.length) {
          let node = nodes[0];
          console.log(this.vModel, node.value, node.data);
          this.form.id = node.data.id;
          this.form.code = node.data.code;
          this.form.post = node.data.postCode;
          this.form.region = val.join(" ");
          this.form.regionSep = val;
          this.form.country = this.$refs.select.$refs.reference.value;
          this.form.countryCode = this.countryCode;
        } else {
          this.form.id = '';
          this.form.code = '';
          this.form.post = '';
          this.form.region = '';
          this.form.regionSep = val;
          this.form.country = '';
          this.form.countryCode = '';
        }
        if(this.changeOutter){
          this.changeOutter();
        }
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/regionSelect/inner.vue